// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleFilled16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-filled': IconCircleFilled;
    }
}

/**
 * The icon component for the 'circleFilled' icon
 */
export class IconCircleFilled extends Icon {
    public constructor() {
        super(circleFilled16X16);
    }
}

registerIcon('icon-circle-filled', IconCircleFilled);
export const iconCircleFilledTag = 'nimble-icon-circle-filled';
